export const questions = {
    "gameType": "Calendar",
    "glo": []
}